import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { useWizardSteps } from '../../hooks/useWizardSteps';
import { Bullet, Connector, Container, Label, StepItem } from './styles';

const Steps = (): React.ReactElement => {
  const { steps, currentIndex } = useWizardSteps();

  return (
    <Container>
      <ol>
        {steps.map((item, index) => {
          const done = index < currentIndex;
          const current = index === currentIndex;

          return (
            <StepItem key={item.label}>
              {index > 0 && <Connector done={done || current} />}
              <Bullet done={done} current={current}>
                {done ? <FaCheck size={11} /> : index + 1}
              </Bullet>
              <Label done={done} current={current}>
                {item.label}
              </Label>
            </StepItem>
          );
        })}
      </ol>
    </Container>
  );
};

export default Steps;
